"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// import isNil from 'lodash/isNil'
var isNil = function isNil(v) {
  return v === undefined || v === null;
};

exports.default = isNil;


//////////////////
// WEBPACK FOOTER
// ./~/coact-utils/isNil.js
// module id = 1128
// module chunks = 0